export class SelectedExtractionDto {
  constructor(
    public id: number,
    public selected: boolean
  ) {}
}
